export default "__VITE_ASSET__bIc6oSlF__"